import styled from 'styled-components';

export const StepperWrapper = styled.div`
  width: 100%;
  height: 76px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  padding: 18px;
`;
